import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { readSession } from '../../utils/session';
import { toastify } from '../Toast';

// mode preserves the caller's existing post-acceptance behavior.
export default function useTeamInvitation(mode = 'verify') {
  const { search } = useLocation();
  const navigate = useNavigate();
  const request = useRef(null);
  useEffect(() => {
    let active = true;
    const session = readSession();
    const invite = new URLSearchParams(search).get('tokenId') || localStorage.getItem('settingsToken');
    if (!session || !invite) return;
    const key = JSON.stringify([invite, session.token, session.user._id, mode]);
    if (request.current?.key !== key) {
      const accept = async () => {
        const config = { headers: { Authorization: `Bearer ${session.token}` } };
        const verification = await axios.post(`${process.env.REACT_APP_API}users/token-verify`, { token: invite }, config);
        if (mode === 'verify') return verification;
        return axios.post(`${process.env.REACT_APP_API}team/accept-invitation`, {
          tokenId: invite, recipientUserId: session.user._id,
        }, config);
      };
      request.current = { key, promise: accept() };
    }
    request.current.promise.then(response => {
      if (!active || mode === 'verify') return;
      const current = readSession();
      if (current?.token !== session.token || current?.user._id !== session.user._id) return;
      if (localStorage.getItem('settingsToken') === invite) localStorage.removeItem('settingsToken');
      if (mode === 'subscription' || mode === 'team') {
        const field = mode === 'subscription' ? 'isActiveSubscription' : 'isTeamMember';
        localStorage.setItem('userData', JSON.stringify({ ...current.user, [field]: true }));
        navigate('/app/buckets');
      }
      const message = response?.data?.message;
      toastify('success', typeof message === 'string' ? message : 'Invitation accepted');
    }).catch(error => {
      if (!active) return;
      const message = error?.response?.data?.message;
      toastify('error', typeof message === 'string' && message ? message : 'Unable to verify the invitation. Please try again.');
    });
    return () => { active = false; };
  }, [mode, navigate, search]);
}
